// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-n_fm","advertDetailContactItem__link":"c-n_fn"};